import React from "react";
import AttributeSelectionBox from "../AttributeSelectionBox";
import AttributeSelectionRow from "../AttributeSelectionRow";

export default class AttributeSelectionContainer extends React.Component {
  render() {
    const { attributes, onSelectAttribute, searchState } = this.props;

    return (
      <div className="w-full bg-white px-4 rounded shadow-blur-lg">
        {attributes.map((attribute, key) => {
          const currentRefinement = searchState.refinementList
            ? searchState.refinementList[attribute.refinement]
              ? searchState.refinementList[attribute.refinement]
              : null
            : null;

          return (
            <AttributeSelectionBox
              isLastElement={key === attributes.length - 1}
              key={key}
              onClick={() => onSelectAttribute(attribute)}
            >
              <AttributeSelectionRow
                attribute={attribute.label}
                currentRefinement={currentRefinement}
              />
            </AttributeSelectionBox>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AttributeSelectionContainer/AttributeSelectionContainer.js